export default __webpack_public_path__ + "static/media/tanishq.cd5c6703.png";